export default {
  DO_LOGIN: 'doLogin',
  DO_LOGOUT: 'doLogout',
  SAVE_LOGIN_DATA: 'saveLoginData',
  RESET_LOGIN_DATA: 'resetLoginData',
  CHECK_TOKEN: 'checkToken',
  OPEN_APP_ERROR_MESSAGE: 'openAppErrorMessage',
  OPEN_APP_SUCCESS_MESSAGE: 'openAppSuccessMessage'
}